export default __webpack_public_path__ + "static/media/Bite of the Winter Sun.7589212b.jpg";